import React from 'react';


const PrimarySection = (props) => {
	return (
		<section className="primary-section">
			{props.children}
		</section>
	);
};

export default PrimarySection;
